
import Vue from 'vue'
import Vuex from 'vuex'
import sessionLogItemTypes from "../../lib/SessionLogItemTypes";


Vue.use(Vuex);


let timeline = new class {
    constructor() {

        let filterItems = sessionLogItemTypes.getCategories();

        this.state = {
            selectedDisplayMode: 'Timeline',
            availableDisplayMode: [
                { text: 'Timeline', value: 'Timeline' },
                { text: 'Table', value: 'Table' }
            ],
            availableItemTypes: filterItems.map(function(item) {
                return { text: item.label, value: item };
            }),
            selectedItemTypes: filterItems.filter(x => x.value != sessionLogItemTypes.CategoryDevice),
        };

        this.getters = {
            availableItemTypes:(state) => state.availableItemTypes,
            selectedItemTypes:(state) => state.selectedItemTypes,

            selectedDisplayMode:(state) => state.selectedDisplayMode,
            availableDisplayMode:(state) => state.availableDisplayMode,

        };

        this.mutations = {
            setSelectedDisplayMode(state, value) {
                state.selectedDisplayMode = value;
            },
            setSelectedItemTypes(state, value) {
                state.selectedItemTypes = value;
            },
        };

        this.actions = {

            changeDisplayMode ({ commit }, selected ) {
                commit('setSelectedDisplayMode', selected);
            },
            changeItemTypes ({ commit }, selected ) {
                commit('setSelectedItemTypes', selected);
            },
        }

    }

}

const state = {
    ...timeline.state,
};
const getters = {
    ...timeline.getters,
};
const actions = {
    ...timeline.actions,
};
const mutations = {
    ...timeline.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};